module.exports = __webpack_public_path__ + "img/77324.e33d7c48.svg";